import Input from '../../../form/Input';
import { useCallback } from 'react';

const CDinfo = ({
  loginID,
  name,
  setName,
  telNo,
  setTelNo,
  createdAt,
  updatedAt,
}: {
  loginID: string;
  name: string;
  setName: React.Dispatch<React.SetStateAction<string>>;
  telNo: string;
  setTelNo: React.Dispatch<React.SetStateAction<string>>;
  createdAt: string;
  updatedAt: string;
}) => {
  const onChangeName = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => setName(e.target.value),
    [setName]
  );

  const onChangeTelNo = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      let value = e.target.value.replace(/\D/g, ''); // 숫자만 남기기

      // 최대 글자수 11자리로 제한
      if (value.length > 11) {
        value = value.slice(0, 11);
      }

      // 전화번호 형식 적용
      if (value.length > 3 && value.length <= 7) {
        value = `${value.slice(0, 3)}-${value.slice(3)}`;
      } else if (value.length > 7) {
        value = `${value.slice(0, 3)}-${value.slice(3, 7)}-${value.slice(7)}`;
      }

      setTelNo(value);
    },
    [setTelNo]
  );
  return (
    <div className="my_customer_wrapper">
      <h1 className="customer_detail_title">계정 정보</h1>
      <div className="customer_detail_row">
        <h2 className="customer_detail_sub_title">ID</h2>
        <div className="customer_detail_divide"></div>
        <div className="customer_detail_info">{loginID}</div>
      </div>
      <div className="customer_detail_row">
        <h2 className="customer_detail_sub_title">이름</h2>
        <div className="customer_detail_divide"></div>
        <Input
          className="customer_detail_info"
          value={name}
          onChange={onChangeName}
          style={{ height: 36, width: 240 }}
          textAlign="left"
        />
      </div>
      <div className="customer_detail_row">
        <h2 className="customer_detail_sub_title">전화번호</h2>
        <div className="customer_detail_divide"></div>
        <Input
          className="customer_detail_info"
          value={telNo}
          onChange={onChangeTelNo}
          style={{ height: 36, width: 240 }}
          textAlign="left"
        />
      </div>
      <div className="customer_detail_row">
        <h2 className="customer_detail_sub_title">생성일</h2>
        <div className="customer_detail_divide"></div>
        <div className="customer_detail_info">{createdAt}</div>
      </div>
      <div className="customer_detail_row">
        <h2 className="customer_detail_sub_title">수정일</h2>
        <div className="customer_detail_divide"></div>
        <div className="customer_detail_info">{updatedAt}</div>
      </div>
    </div>
  );
};

export default CDinfo;
